/*************
このファイルは convert-locales コマンドにより自動生成されたものです
修正するには大元のymlファイルを編集し、convert-locales コマンドを実行してください
*************/
export const ids = {
  dialog: {
    cancel: 'dialog.cancel',
    ok: 'dialog.ok',
  },
  deviceFamilyNames: {
    '0': 'deviceFamilyNames.0',
    '1': 'deviceFamilyNames.1',
    '2': 'deviceFamilyNames.2',
  },
  pullToRefresh: {
    pullToRefresh: 'pullToRefresh.pullToRefresh',
    releaseToRefresh: 'pullToRefresh.releaseToRefresh',
    refreshing: 'pullToRefresh.refreshing',
  },
  alert: {
    error: 'alert.error',
    startBinaryInstall: 'alert.startBinaryInstall',
  },
  prompt: {
    inputDisplayName: 'prompt.inputDisplayName',
  },
  confirm: {
    leaveTest: 'confirm.leaveTest',
  },
  loginForm: {
    submit: 'loginForm.submit',
    email: 'loginForm.email',
    password: 'loginForm.password',
  },
  appFileInfo: {
    releaseDate: 'appFileInfo.releaseDate',
    TTL: 'appFileInfo.TTL',
    size: 'appFileInfo.size',
    compatibility: 'appFileInfo.compatibility',
    targetDeviceFamily: 'appFileInfo.targetDeviceFamily',
  },
  samlLoginForm: {
    help: 'samlLoginForm.help',
    enterpriseName: 'samlLoginForm.enterpriseName',
    enterpriseNameFormat: 'samlLoginForm.enterpriseNameFormat',
    submit: 'samlLoginForm.submit',
  },
  signUpForm: {
    submit: 'signUpForm.submit',
    email: 'signUpForm.email',
    password: 'signUpForm.password',
    username: 'signUpForm.username',
    termsAccept: 'signUpForm.termsAccept',
    emailValidatedMessage: 'signUpForm.emailValidatedMessage',
  },
  signUpEmailForm: {
    email: 'signUpEmailForm.email',
    help: 'signUpEmailForm.help',
    submit: 'signUpEmailForm.submit',
  },
  signUpValidateForm: {
    code: 'signUpValidateForm.code',
    sentMessage: 'signUpValidateForm.sentMessage',
    resend: 'signUpValidateForm.resend',
    submit: 'signUpValidateForm.submit',
  },
  appInstall: {
    version: 'appInstall.version',
    updatedAt: 'appInstall.updatedAt',
    overwriteInstall: 'appInstall.overwriteInstall',
    unsupportedOverwriteInstall: 'appInstall.unsupportedOverwriteInstall',
    install: 'appInstall.install',
    binaryOverSize: 'appInstall.binaryOverSize',
    expiredProvisioningProfile: {
      developer: 'appInstall.expiredProvisioningProfile.developer',
      tester: 'appInstall.expiredProvisioningProfile.tester',
    },
    unsupportedDevice: 'appInstall.unsupportedDevice',
    unsupportedOsVersion: 'appInstall.unsupportedOsVersion',
    notRegisteredIphone: {
      developer: 'appInstall.notRegisteredIphone.developer',
      tester: 'appInstall.notRegisteredIphone.tester',
    },
    duplicateIconNotice: 'appInstall.duplicateIconNotice',
    enterpriseAcceptProfile: 'appInstall.enterpriseAcceptProfile',
    adhocEnableDeveloperMode: 'appInstall.adhocEnableDeveloperMode',
  },
  appDetail: {
    releaseNote: 'appDetail.releaseNote',
    info: 'appDetail.info',
    distributionUpdatedDate: 'appDetail.distributionUpdatedDate',
  },
  commentDetail: {
    reply: 'commentDetail.reply',
    unknownUserName: 'commentDetail.unknownUserName',
  },
  commentModal: {
    placeholder: {
      defult: 'commentModal.placeholder.defult',
      withReplyName: 'commentModal.placeholder.withReplyName',
    },
    cancel: 'commentModal.cancel',
    submit: 'commentModal.submit',
  },
  configurationProfileInfo: {
    suggestUpdate: 'configurationProfileInfo.suggestUpdate',
    confirm: {
      reInstall: 'configurationProfileInfo.confirm.reInstall',
    },
  },
  loginPageLayout: {
    oAuthLogin: {
      linkTitle: 'loginPageLayout.OAuthLogin.linkTitle',
      github: 'loginPageLayout.OAuthLogin.github',
      google: 'loginPageLayout.OAuthLogin.google',
    },
    SAML: 'loginPageLayout.SAML',
    signup: 'loginPageLayout.signup',
    reminder: 'loginPageLayout.reminder',
  },
  configurationProfilePageLayout: {
    title: 'configurationProfilePageLayout.title',
    deploygate: 'configurationProfilePageLayout.deploygate',
    help: 'configurationProfilePageLayout.help',
    udidHelp: 'configurationProfilePageLayout.udidHelp',
    install: 'configurationProfilePageLayout.install',
    guide1: 'configurationProfilePageLayout.guide1',
    guide2: 'configurationProfilePageLayout.guide2',
    logout: 'configurationProfilePageLayout.logout',
    installNotice: 'configurationProfilePageLayout.installNotice',
  },
  signUpPageLayout: {
    banner: 'signUpPageLayout.banner',
    login: 'signUpPageLayout.login',
  },
  appsPageLayout: {
    title: 'appsPageLayout.title',
    availableApps: 'appsPageLayout.availableApps',
    logout: 'appsPageLayout.logout',
    login: 'appsPageLayout.login',
    reInstall: 'appsPageLayout.reInstall',
    noAvailableApps: 'appsPageLayout.noAvailableApps',
    waitForEnginner: 'appsPageLayout.waitForEnginner',
    notificationSetting: 'appsPageLayout.notificationSetting',
  },
  appsPage: {
    confirm: {
      logout: 'appsPage.confirm.logout',
      reInstall: 'appsPage.confirm.reInstall',
    },
    terms: {
      title: 'appsPage.terms.title',
    },
  },
  appDetailPageLayout: {
    title: 'appDetailPageLayout.title',
    otherVersions: 'appDetailPageLayout.otherVersions',
    showOtherVersions: 'appDetailPageLayout.showOtherVersions',
  },
  appSearchPageLayout: {
    title: 'appSearchPageLayout.title',
    inputPlaceholder: 'appSearchPageLayout.inputPlaceholder',
  },
  distributionDetailPageLayout: {
    waitingForTester: {
      explanationHeader:
        'distributionDetailPageLayout.waitingForTester.explanationHeader',
      explanationBody:
        'distributionDetailPageLayout.waitingForTester.explanationBody',
      laterGuideHeader:
        'distributionDetailPageLayout.waitingForTester.laterGuideHeader',
      laterGuideBody:
        'distributionDetailPageLayout.waitingForTester.laterGuideBody',
    },
    displayName: 'distributionDetailPageLayout.displayName',
    comment: 'distributionDetailPageLayout.comment',
    changeDisplayName: 'distributionDetailPageLayout.changeDisplayName',
    leave: 'distributionDetailPageLayout.leave',
    notification: 'distributionDetailPageLayout.notification',
    changeNotificationOn: 'distributionDetailPageLayout.changeNotificationOn',
    changeNotificationOff: 'distributionDetailPageLayout.changeNotificationOff',
  },
  commentsPageLayout: {
    title: 'commentsPageLayout.title',
  },
  commentsPage: {
    confirm: {
      delete: 'commentsPage.confirm.delete',
    },
  },
  notificationSettingPageLayout: {
    title: 'notificationSettingPageLayout.title',
    submit: 'notificationSettingPageLayout.submit',
    remove: 'notificationSettingPageLayout.remove',
    placeholder: 'notificationSettingPageLayout.placeholder',
  },
  notificationSettingPage: {
    sendEmailActivation: 'notificationSettingPage.sendEmailActivation',
    confirm: {
      delete: 'notificationSettingPage.confirm.delete',
    },
  },
  emailActivationPage: {
    title: 'emailActivationPage.title',
    success: 'emailActivationPage.success',
    error: {
      tokenInvalid: 'emailActivationPage.error.tokenInvalid',
    },
  },
  invitation: {
    headerTitle: 'invitation.headerTitle',
    invitee: 'invitation.invitee',
    message: 'invitation.message',
    signUpHelp: 'invitation.signUpHelp',
    signUpForApp: 'invitation.signUpForApp',
    signUpForGroup: 'invitation.signUpForGroup',
    loginHelp: 'invitation.loginHelp',
    login: 'invitation.login',
  },
  unavailableInvitation: {
    title: 'unavailableInvitation.title',
    message: 'unavailableInvitation.message',
    back: 'unavailableInvitation.back',
  },
  showExceptionError: {
    title: 'showExceptionError.title',
    subTitle: 'showExceptionError.subTitle',
    back: 'showExceptionError.back',
  },
  emailValidation: {
    invalid: {
      format: 'emailValidation.invalid.format',
    },
  },
  error: {
    notSafari: {
      requiredSafari: 'error.notSafari.requiredSafari',
      openSafari: 'error.notSafari.openSafari',
      copyHtml: 'error.notSafari.copyHtml',
      copyUrl: 'error.notSafari.copyUrl',
    },
    hint: {
      cookieOff: 'error.hint.cookieOff',
      privateBrowser: 'error.hint.privateBrowser',
    },
  },
  api: {
    error: {
      distributionNotFound: 'api.error.distributionNotFound',
      general: 'api.error.general',
      invalidEmailOrPassword: 'api.error.invalidEmailOrPassword',
      notConnectedToInternet: 'api.error.notConnectedToInternet',
      someRequiredParamsIsBlank: 'api.error.someRequiredParamsIsBlank',
      notAcceptedTerms: 'api.error.notAcceptedTerms',
      thisNameIsAlreadyUsed: 'api.error.thisNameIsAlreadyUsed',
      thisEmailIsAlreadyUsed: 'api.error.thisEmailIsAlreadyUsed',
      tokenIsInvalid: 'api.error.tokenIsInvalid',
      noSessionFound: 'api.error.noSessionFound',
      noEnterpriseFound: 'api.error.noEnterpriseFound',
      SamlAuthenticationDisabled: 'api.error.SamlAuthenticationDisabled',
      distributionDisplayNameInvalidCharacters:
        'api.error.distributionDisplayNameInvalidCharacters',
      invalidEmail: 'api.error.invalidEmail',
      thisDistributionLimitedAccesses:
        'api.error.thisDistributionLimitedAccesses',
      thisIphoneWasLooggedIn: 'api.error.thisIphoneWasLooggedIn',
      notFoundIphone: 'api.error.notFoundIphone',
      thisEmailIsAlreadyInUse: 'api.error.thisEmailIsAlreadyInUse',
      theseTransactionKeyAndCodeWereInvalid:
        'api.error.theseTransactionKeyAndCodeWereInvalid',
      TheTransactionKeyHasBeenInvalidated:
        'api.error.TheTransactionKeyHasBeenInvalidated',
      TooManyRequests: 'api.error.TooManyRequests',
      SsoAuthDueDateOver: 'api.error.SsoAuthDueDateOver',
      NotFoundOrNeedToLogIn: 'api.error.NotFoundOrNeedToLogIn',
      name: {
        too_short: 'api.error.name.too_short',
        too_long: 'api.error.name.too_long',
        invalid: 'api.error.name.invalid',
        taken: 'api.error.name.taken',
      },
      password: {
        length: 'api.error.password.length',
      },
    },
  },
};
